import React from 'react';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import { isCountryColombia } from 'constants/regions';
import { useTranslation } from 'react-i18next';

const Divider = styled.hr`
  border: none;
  border-top: solid 1px #ebebeb;
  margin: 16px 0;
  width: 100%;
`;

const ContainerLink = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const Link = styled.a`
  font-size: 14px;
  color: #43b02a;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: #9ba030;
  }
`;

export default function Boton({ id, text, onClick, type, style, disabled }) {
  const defaultStyle = {
    backgroundColor: ' #43b02a',
    color: 'white',
    fontSize: '14px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    width: '160px',
    heigth: '40px',
    /*  marginTop: "20px",
    marginBottom: "40px", */
    textTransform: 'none',
    ...style,
  };

  const { t } = useTranslation();
  return (
    <>
      <Button
        id={id || 'button'}
        variant="contained"
        style={defaultStyle}
        disabled={disabled}
        onClick={onClick}
        type={type || 'button'}
      >
        {text}
      </Button>

      <>
        <Divider />
        <ContainerLink>
          <Link href={t('needHelp.needHelpUrl')} target="_blank" rel="noopener noreferrer">
            {t('needHelp.needHelp')}
          </Link>
        </ContainerLink>
      </>
    </>
  );
}
